exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TabsBar_checked__Gt5v8{color:#3dcd58}.TabsBar_checked__Gt5v8:after{display:block;position:absolute;content:\"\";height:4px;width:100%;background-color:#3dcd58;left:0;bottom:0}.TabsBar_container__C_KHL{box-shadow:0 3px 5px -3px rgba(51,51,51,.14)}.TabsBar_wrapper__2OoKt{font-size:16px;line-height:50px;border-top:1px solid #e7e6e6;height:50px;width:100%;overflow-y:hidden;overflow-x:auto;white-space:nowrap}.TabsBar_elements__3WRTC{display:inline-block;position:relative;cursor:pointer}.TabsBar_elements__3WRTC:not(:last-child){margin-right:30px}@media only screen and (min-width:961px){.TabsBar_elements__3WRTC:hover{color:#3dcd58}.TabsBar_elements__3WRTC:hover:after{display:block;position:absolute;content:\"\";height:4px;width:100%;background-color:#3dcd58;left:0;bottom:0}.TabsBar_elements__3WRTC:hover:not(.TabsBar_checked__Gt5v8):after{background-color:transparent}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"checked": "TabsBar_checked__Gt5v8",
	"container": "TabsBar_container__C_KHL",
	"wrapper": "TabsBar_wrapper__2OoKt",
	"elements": "TabsBar_elements__3WRTC"
};